// extracted by mini-css-extract-plugin
export var leadHero = "styles-module--leadHero--3luyq";
export var media = "styles-module--media--1Xynu";
export var description = "styles-module--description--PWNhL";